import { styled } from '@mui/material';
import { Icon } from '@elements';
var StyledButtonIcon = styled(Icon)(function (_ref) {
  var theme = _ref.theme;
  return {
    marginRight: theme.spacing(1)
  };
});
export { StyledButtonIcon };